import { Component, ViewChild } from '@angular/core';
import { FrontendFormDefinition } from '../../models/frontend-form-definition.model';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { FrontendFieldDefinition } from '../../models/frontend-field-definition.model';
import { SmFormComponent } from '../sm-form/sm-form.component';
import { ICellEditorParams } from 'ag-grid-community';

@Component({
  selector: 'sm-table-cell-editor',
  templateUrl: './sm-table-cell-editor.component.html',
  styleUrl: './sm-table-cell-editor.component.scss'
})
export class SmTableCellEditorComponent implements ICellEditorAngularComp {

  form: FrontendFormDefinition;
  
  @ViewChild("formComponent")
  formComponent: SmFormComponent;
  
  params: ICellEditorParams;

  agInit(params: ICellEditorParams): void {
    this.params = params;
    this.form = new FrontendFormDefinition([(params as any).editor as FrontendFieldDefinition]);
    this.form.fields[0].hasLabel = false;
    this.form.fields[0].onValueChanged = () => {
      this.params.stopEditing();
    };
    this.form.fields[0].tableCellEditor = this;
    this.form.fields[0].value = params.value;
  }

  afterGuiAttached(): void {
    this.formComponent?.thisComponentAsTableEditorInited();
  }

  getValue(): any {
    return this.form.fields[0].getValue();
  }
}
